import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromJob from './job.reducer';
export const locumsFeatureKey = 'locums-store';

export interface LocumsStoreState {
    job: fromJob.JobState;
}

export const reducers: ActionReducerMap<LocumsStoreState> = {
    job: fromJob.jobReducer
};

export const locumsFeature = createFeatureSelector<LocumsStoreState>(locumsFeatureKey);
